import { render, staticRenderFns } from "./CommentEventManage.vue?vue&type=template&id=75d53948&scoped=true&"
import script from "./CommentEventManage.vue?vue&type=script&lang=js&"
export * from "./CommentEventManage.vue?vue&type=script&lang=js&"
import style0 from "./CommentEventManage.vue?vue&type=style&index=0&id=75d53948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d53948",
  null
  
)

export default component.exports